<script lang="ts">
    import { langField } from "../../../i18n"
    import { firstProductImage } from "../../../utils"
    import { storeLasersheetEngravingToLocalStorage } from "../product/widgets/helper"
    import Lasersheets from "../product/widgets/lasersheet/Lasersheets.svelte"

    let {
        item,
        deactivateLink = false,
        useGridMobile = true,
        additionalContentSnippet,
    }: {
        item: CartItem
        deactivateLink?: boolean
        useGridMobile?: boolean
        additionalContentSnippet?: () => any
    } = $props()

    const hasLasersheets = $derived(!!(item.product.images?.length && item.product.lasersheet_configurator?.length))
</script>

{#snippet ImageContentSnippet()}
    <img
        src={firstProductImage(item.product, "180-shadow" + (hasLasersheets ? "-fixed" : ""))}
        alt={langField(item.product.name, "")}
        loading="lazy"
    />
    {#if hasLasersheets}
        <Lasersheets product={item.product} user_inputs={item.user_inputs} image={item.product?.images?.[0]} />
    {/if}
{/snippet}

<div class="image" class:useGridMobile>
    {#if deactivateLink}
        <div class="a-style" style="height: 100%">
            {@render ImageContentSnippet()}
            {#if additionalContentSnippet}
                {@render additionalContentSnippet()}
            {/if}
        </div>
    {:else}
        <a
            style="height: 100%"
            onclick={() => {
                storeLasersheetEngravingToLocalStorage(item.user_inputs)
            }}
            href="/product/{item.product.code}_{langField(item.product.slug, '')}"
        >
            {@render ImageContentSnippet()}
            {#if additionalContentSnippet}
                {@render additionalContentSnippet()}
            {/if}
        </a>
    {/if}
</div>

<style lang="less">
    @import "../../../css/variables.less";
    .image {
        position: relative;
        .flex();
        align-items: center;
        justify-content: center;
        width: 100%;
        height: auto;
        margin-bottom: 15px;
        @media @mobile {
            width: 100%;
            height: 150px;
            margin-right: 15px;
        }

        @media @tablet {
            max-width: 200px;
        }
        a,
        .a-style {
            display: block;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            padding: 0.5rem;
            img {
                width: auto;
                height: 100%;
                object-fit: contain;
            }
        }
    }

    @media @max-mobile {
        .image.useGridMobile {
            order: 1;
            grid-column: span 2;
        }
        .image {
            width: 100%;
        }
    }
</style>
